










import { round } from '@/utils/CommonUtils'
import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class InputNumber extends Vue {
  @Prop() readonly value!: string | number
  @Prop({ type: Boolean, default: false }) readonly alignLeft!: boolean
  @Prop() readonly decimalPlaces?: number

  get _value () {
    let value = this.value
    if (typeof value === 'string') {
      value = parseInt(value)
    }

    if (this.decimalPlaces !== undefined) {
      value = round(value, this.decimalPlaces)
    }

    return value
  }

  set _value (val: number) {
    this.$emit('input', val)
  }
}
